/**
 * Story 546, design byok.notice.web: the alert at the top of the story list
 * while the project's own AI service has something the customer must fix
 * (credit or spend limit, a refused key, a wrong address or model, or a saved
 * key Ceetrix cannot open). Every member sees it; it cannot be dismissed and
 * stays until the failure clears. Waits on the provider's own trouble show no
 * alert, because nobody in the project can fix them.
 */
import { useProjectSettings } from '../../hooks/useProjectSettings';
import {
  AI_SERVICE_ALERT_TITLE,
  AI_SERVICE_ALERT_LINK,
  AI_SERVICE_LAST_WORKED,
  AI_SERVICE_STATE_MESSAGES,
} from './projectSettingsCopy';
import './AiServiceAlert.css';

export function AiServiceAlert({ projectSlug, onOpen }: { projectSlug: string; onOpen: () => void }) {
  const { data } = useProjectSettings(projectSlug);
  const service = data?.ai_service;
  if (!service || !service.alert) return null;
  const state = service.state === 'customer_fix' || service.state === 'stopped' || service.state === 'unusable' ? service.state : null;
  if (!state) return null;

  return (
    <div className="ai-service-alert" role="alert">
      <p className="ai-service-alert__title">{AI_SERVICE_ALERT_TITLE}</p>
      <p className="ai-service-alert__body">
        {AI_SERVICE_STATE_MESSAGES[state]}
        {service.reason ? ` The provider said: ${service.reason}.` : ''}
        {service.last_worked_at ? ` ${AI_SERVICE_LAST_WORKED(new Date(service.last_worked_at).toLocaleString())}` : ''}
      </p>
      <button
        type="button"
        className="ai-service-alert__link"
        onClick={onOpen}
      >
        {AI_SERVICE_ALERT_LINK}
      </button>
    </div>
  );
}
